// pages/Landing.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Landing.css';
import forte_logo from '../../assets/forte_logo_white.svg';
import abbvie_logo from '../../assets/abbvie_logo_2.png';
import abbvie_logo_main from '../../assets/abbvie_logo_white.svg';
import cognitoService from '../../services/cognitoService';
import PasswordInput from '../../components/common/PasswordInput';

const Landing = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await cognitoService.signIn(username, password);
      navigate('/home');
    } catch (err) {
      setError(err.message || 'Login failed');
      setIsLoading(false);
    }
  };

  return (
    <div className={`landing-page${isLoading ? ' transitioning' : ''}`}>
      <div className="background-logos">
        <img src={forte_logo} alt="Forte Logo" className="bg-logo forte-logo" />
      </div>
      <div className="landing-container">
        <div className="landing-content">
          <h1 className="landing-title">AI Test Case Assistant</h1>
          <p className="landing-subtitle">Your intelligent companion for test case development and analysis</p>
          <div className="auth-section">
            <form onSubmit={handleLogin} className="auth-form">
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={e => setUsername(e.target.value)}
                disabled={isLoading}
                autoComplete="username"
                required
              />
              <PasswordInput
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Password"
                disabled={isLoading}
                autoComplete="current-password"
                required
              />
              {error && <div className="auth-error">{error}</div>}
              <button className="primary-button" type="submit" disabled={isLoading}>
                {isLoading ? 'Logging in...' : 'Login'}
              </button>
            </form>
            {/* <div className="auth-toggle">
              <span>Don't have an account?</span>
              <button type="button" onClick={() => navigate('/signup')} disabled={isLoading} className="link-button">Create one</button>
            </div> */}
            <div className="auth-toggle">
              <button type="button" onClick={() => navigate('/forgot-password')} disabled={isLoading} className="link-button">Forgot password?</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;